import { useAuthStore, useGeneralStore } from '@core/global'

// Browser-only session state: access tokens and the theme live in localStorage.
// (Replaces LoadGeneral's restoreSession calls, main.ts and App.vue in the Vite app.
// generalStore.restoreSession() is not used because it would reload the web config.)
export default defineNuxtPlugin((nuxtApp) => {
    const authStore = useAuthStore()
    const generalStore = useGeneralStore()

    authStore.restoreSession()
    authStore.requestMemberInfo()
    authStore.getAuthorizedUser()

    // After hydration, so the theme switch first renders like the server HTML. The page itself
    // is already themed by the inline script in server/plugins/html-shell.ts.
    nuxtApp.hook('app:mounted', () => {
        // generalStore.setTheme(localStorage.getItem('theme') || generalStore.theme)
    })
})
